import Explore from './pages/explore';

function App() {
  return (
    <Explore></Explore>
  );
}

export default App;
